import { memo } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Paper } from "@mui/material"
import { Card, Col, Row } from "antd"
import Link from "next/link"
import { AppointmentState, CardActions, defaultAppointmentState, inquiryDefaultState, InquiryState, PopOverState } from '../recommended/CardActions';

import { MyImage } from "../myImage"
//@ts-ignore
import styles from '../recommended/css/recommend.module.scss'
import moment from "moment"
import { faClock } from "@fortawesome/free-regular-svg-icons"
import { generateImage, generateImageFallback, generateLocation, getPropertyPrice } from "../recommended"
import { faBath, faBed, faBuilding, faCar, faMountain, faVectorSquare } from "@fortawesome/free-solid-svg-icons"

const getIcon = (iconName, value, t, locale, id) => {
    if(iconName === null) {
        return undefined;
    }

    let iconCom = undefined;
    let unit = undefined;
    let prefix = undefined;
    let transValue = value !== null? value: '-';
    let span = 8;
    
    if(iconName === 'Bedroom') {
        iconCom = faBed
        unit = t('bedroom', { ns: 'common' });
    } else if(iconName === 'Bathroom') {
        iconCom = faBath;
        unit = t('bathroom', { ns: 'common' });
    } else if(iconName === 'storeys') {
        iconCom = faBuilding;
        unit = t('floor', { ns: 'common' });
    } else if(iconName === 'property_Size') {
        iconCom = faVectorSquare;
        // prefix = `${t('P_size')}`;
        unit = t('square meter', { ns: 'common' });
    } else if(iconName === 'Land_Size') {
        iconCom = faMountain;
        unit = t('square wa', { ns: 'common' });
    } else if(iconName === 'property_Parking') {
        iconCom = faCar;
        unit = t('Parking', { ns: 'common' }); 
    } else if(iconName === 'Land_Rai,Land_Nga,Land_Sqw') {
        iconCom = undefined; //faVectorSquare;
        const valueList = transValue.split(',');
        // prefix = `${t('ไร่ งาน ตร.ว.')}`;
        transValue = [
            <span className={styles.cardDetailNumber} >{`${valueList[0] !== null? valueList[0]: '-'}`}</span>,
            <span>{`${t('rai', { ns: 'common' })}, `}</span>,
            <span className={styles.cardDetailNumber} >{`${valueList[1] !== null? valueList[1]: '-'}`}</span>,
            <span>{`${t('ngan', { ns: 'common' })}, `}</span>,
            <span className={styles.cardDetailNumber} >{`${valueList[2] !== null? valueList[2]: '-'}`}</span>,
            <span>{t('square wa', { ns: 'common' })}</span>  
        ]
        // `${valueList[0]} ${t('ไร่')}, ${valueList[1]} ${t('งาน')}, ${valueList[2]} ${t('ตร.ว.')}`
        span = 16;
    } else if(iconName === 'Depth') {
        iconCom = undefined; // faVectorSquare;
        prefix = `${t('depth', { ns: 'common' })} `;
        unit = t('m.');
    } else if(iconName === 'vacant land') {
        span=0; // Remove because no data on our DB
        iconCom = undefined; 
        prefix = `${t('vacant', { ns: 'common' })} `;
    } else if(iconName === 'Frontage') {
        iconCom = undefined; 
        prefix = `${t('width', { ns: 'common' })} `;
        unit = t('m.');
    }  else if(iconName === 'color') {
        span=0;
        iconCom = undefined; //faVectorSquare;
        prefix = `${t('color', { ns: 'common' })} `;
    } else if(iconName === 'foreignerQuota') {
        span=0;
        iconCom = undefined; //faVectorSquare;
        prefix = `${t('quota', { ns: 'common' })} `;
    } else if(iconName === 'property_Floor') {
        console.log("locale: ", locale);
        if(locale === 'en'){
            iconCom = faBuilding;
            unit = `${t('floor-unit', { ns: 'common' })}`;
        } else {
            iconCom = faBuilding;
            prefix = `${t('floor-unit', { ns: 'common' }) }`;
            unit = ' ';
        }
    } 
    return (
        <Col span={span} style={{fontSize: '12px'}} key={`card-detail-${id}-${iconName}`}>
            {
                // iconCom ? <FontAwesomeIcon icon={iconCom} className={styles.detailIcon}/> : undefined
            }
            { 
                unit ? [
                    <span style={{paddingRight: '4px'}}>{`${prefix ?? ''}`}</span>,
                    <span className={styles.cardDetailNumber} >{`${value ? value: '-'}`}</span>,
                    <span>{`${unit}`}</span>
                ]
                : [
                    <span style={{paddingRight: '4px'}}>{`${prefix ?? ''}`}</span>,
                    ...transValue
                ]
            }
        </Col>  
    )
}

const CardDetail = (props) => {

    const { 
        action,
        property,
        carddetail, t,
        locale,
        project
    } = props;

    const {
        bedroom,
        bathroom,
        property_size,
        floor,
        parking,
    } = property;
    
    const isSell =  action === t('ขาย');

    if(carddetail === null) {
        return <Row></Row>;
    }

    const detail = carddetail[isSell? 'sell': 'rent'];
    // console.log('CardDetail: ', detail);

    const uniqIcon = [];
    detail.columns.map((a) => {
        uniqIcon.push(a);
    })
    // console.log('uniq: ', _.uniq(uniqIcon));

    const detail_id = `${project.id}-${property.id}`

    return (
        <Row>
        {
            detail.columns.map((column, index) => {
                const value = detail.values[index];
                if(column !== 'storeys') {
                    return getIcon(column, value, t, locale, detail_id);
                }
            })
        }
    </Row>
    )
}

const PropertyItems = memo(({d, t, locale, linkAction}: any) => {
    const type = "property";
    const name = d.property.name[locale.toUpperCase()]
    const location = generateLocation(locale, d);
    const projectName = d.project.name[locale.toUpperCase()] ?? ''
    const action = t('ขาย', { ns: 'common' })
    const imageUrl = generateImage(locale,d, type);
    const imageurlfallback = generateImageFallback(locale,d, type);
    
    return (        
        <Paper key={d.property.id} style={{marginTop:20}}>
        <Card
            key={d.property.id}
            hoverable
            className={styles.normalcard}
            actions={null}
            style={{textAlign:'left'}}
            cover={
                <div className={styles.cardImagecontainer}
                    onClick={() => null}
                    onMouseDown={(e) => null}
                >
                    {
                        (d?.property?.boots_status === 1) ?
                            <div className={styles.exclusiveLabel}>ประกาศ Exclusive</div>
                            : undefined
                    }
                    <Link href={`${linkAction}`}>
                        <MyImage className={styles.cardImage} alt={name || null} src={`${imageUrl}`} width="100%" height="100%"
                            imageurlfallback={`${imageurlfallback}`}
                            onError={function () { }}
                        />
                    </Link>
                </div>
            }
        >
            <div>
                <Row justify="space-between" align="middle" className={styles.postUserContainer} style={{marginBottom:20}}>
                    <Col span={12}>
                        <div className={styles.postuser}>
                            {d.property.code}
                        </div>
                    </Col>
                    <Col span={12}>
                        <div style={{ display: "inline-flex", float: 'right' }}>
                            <FontAwesomeIcon icon={faClock} size="xs" className={styles.detailIcon} />
                            <div className={styles.updatedate} >{`${moment(d.property?.update).fromNow()}`}</div>
                        </div>
                    </Col>
                </Row>

                <div className={styles.priceContainer} >
                        {
                            getPropertyPrice(d, t, locale)
                        }
                </div>
                <div className={styles.detail} style={{marginTop: 8, marginBottom: 10}}>
                    {/* {detail} */}
                    <CardDetail property={d.property} project={d.project}
                        carddetail={d.carddetail} action={action} t={t} locale={locale} />
                </div>
                <div style={{fontSize: '0.9rem'}}>
                    {projectName}
                </div>
                <div style={{color: '#555', marginTop: 8, fontSize: '0.9rem'}}>
                        <Link className="nav-link" href={`${linkAction}`} itemProp="url">
                            {name}
                        </Link>
                </div>
                <p >
                    {/* <span style={{color: '#888', fontSize: '0.8rem'}}> address<br /></span>                     */}
                    <span className={styles.cardlocationcontainer} style={{color: '#333', fontSize: '0.85rem', fontWeight: 'bold'}}>{location}</span>
                </p>
                
            </div>
        </Card>
    </Paper>
    )
})
export default PropertyItems